import { render, staticRenderFns } from "./NextToPlaySquare.vue?vue&type=template&id=f573061c"
import script from "./NextToPlaySquare.vue?vue&type=script&lang=js"
export * from "./NextToPlaySquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports